import { render, staticRenderFns } from "./custom-filepond.vue?vue&type=template&id=574a64c4&scoped=true&"
import script from "./custom-filepond.vue?vue&type=script&lang=ts&"
export * from "./custom-filepond.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a64c4",
  null
  
)

export default component.exports